var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import FetchProvider from './FetchProvider';
import ConfigurationError, { ConfigurationErrorCode } from './errors/configurationError';
import ResolutionError, { ResolutionErrorCode } from './errors/resolutionError';
import { NamingServiceName, } from './types/publicTypes';
import Networking from './utils/Networking';
export function isSupportedAccount(account) {
    return /.+\.bit/.test(account) && account.split('.').every(v => Boolean(v.length));
}
/**
 * Transform hash-style account to dot-style account
 * @param inputAccount
 */
export function toDottedStyle(inputAccount) {
    if (!isSupportedAccount(inputAccount)) {
        return inputAccount;
    }
    if (!inputAccount.includes('#')) {
        return inputAccount;
    }
    const [account, suffix] = inputAccount.split('.');
    const [main, sub] = account.split('#');
    return `${sub}.${main}.${suffix}`;
}
/**
 * Transform dot-style account to hash-style account
 * @param inputAccount
 */
export function toHashedStyle(inputAccount) {
    if (!isSupportedAccount(inputAccount)) {
        return inputAccount;
    }
    if (inputAccount.includes('#')) {
        return inputAccount;
    }
    const parts = inputAccount.split('.');
    if (parts.length === 3) {
        const [sub, main, suffix] = parts;
        return `${main}#${sub}.${suffix}`;
    }
    return inputAccount;
}
export class Das {
    constructor(source = {}) {
        this.name = NamingServiceName.DAS;
        this.toDottedStyle = toDottedStyle;
        this.toHashedStyle = toHashedStyle;
        this.isSupportedAccount = isSupportedAccount;
        this.url = source.url;
        if (source.provider) {
            this.provider = source.provider;
        }
        else if (source.url) {
            this.provider = new FetchProvider(this.name, source.url);
        }
        else {
            throw new ConfigurationError(ConfigurationErrorCode.UnspecifiedUrl, {
                method: NamingServiceName.DAS
            });
        }
        if (source.avatarResolver) {
            this.avatarResolver = source.avatarResolver;
        }
        else {
            this.avatarResolver = 'https://identicons.did.id/avatar/resolve';
        }
    }
    account(account) {
        return __awaiter(this, void 0, void 0, function* () {
            if (!this.isSupportedAccount(account)) {
                throw new ResolutionError(ResolutionErrorCode.UnsupportedService, {
                    account: account,
                });
            }
            const data = yield this.provider.request({
                method: 'das_accountInfo',
                params: [{
                        account,
                    }]
            });
            if (!data.data) {
                // error code = 20007
                throw new ResolutionError(ResolutionErrorCode.UnregisteredAccount, {
                    account: account,
                });
            }
            return Object.assign(Object.assign({}, data.data.account_info), { avatar: `https://identicons.did.id/identicon/${account}` });
        });
    }
    accountById(accountId) {
        return __awaiter(this, void 0, void 0, function* () {
            const data = yield this.provider.request({
                method: 'das_accountInfo',
                params: [{
                        account_id: accountId,
                    }]
            });
            if (!data.data) {
                // error code = 20007
                throw new ResolutionError(ResolutionErrorCode.UnregisteredAccount, {
                    accountId: accountId,
                });
            }
            return Object.assign(Object.assign({}, data.data.account_info), { avatar: `https://identicons.did.id/identicon/${accountId}` });
        });
    }
    getAvatar(account) {
        return __awaiter(this, void 0, void 0, function* () {
            const result = yield Networking.fetch(`${this.avatarResolver}/${account}`);
            return result.json();
        });
    }
    records(account, key) {
        return __awaiter(this, void 0, void 0, function* () {
            if (!this.isSupportedAccount(account)) {
                throw new ResolutionError(ResolutionErrorCode.UnsupportedAccount, {
                    account: account,
                });
            }
            const res = yield this.provider.request({
                method: 'das_accountRecords',
                params: [{
                        account,
                    }]
            });
            const accountData = res.data;
            if (!accountData) {
                throw new ResolutionError(ResolutionErrorCode.UnregisteredAccount, {
                    account: account,
                });
            }
            if (!key) {
                return accountData.records;
            }
            key = key.toLowerCase();
            return accountData.records.filter(record => record.key === key);
        });
    }
    addrs(account, chain) {
        return __awaiter(this, void 0, void 0, function* () {
            return this.records(account, `address.${chain}`);
        });
    }
    accountsForOwner(address, coinType = '60') {
        var _a;
        return __awaiter(this, void 0, void 0, function* () {
            const res = yield this.provider.request({
                method: 'das_accountList',
                params: [{
                        "type": "blockchain",
                        "key_info": {
                            "coin_type": coinType,
                            "key": address
                        }
                    }]
            });
            return (_a = res === null || res === void 0 ? void 0 : res.data) === null || _a === void 0 ? void 0 : _a.account_list;
        });
    }
    reverseRecord(descriptor) {
        return __awaiter(this, void 0, void 0, function* () {
            const res = yield this.provider.request({
                method: 'das_reverseRecord',
                params: [descriptor]
            });
            return res.data.account;
        });
    }
}
Das.toDottedStyle = toDottedStyle;
Das.toHashedStyle = toHashedStyle;
//# sourceMappingURL=data:application/json;base64,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